import { useState } from "react";
import api from "../../../../../features/auth/axiosConfig";
import { notifyError, notifySuccess } from "src/assets/toastService";

interface UseDeleteCustomerProps {
  id: string;
  refreshCustomerList: () => void;
  outStandingBalance: number;
  onClose?: () => void;
}

export const useDeleteCustomer = ({ id, refreshCustomerList, outStandingBalance, onClose }: UseDeleteCustomerProps) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const handleDelete = async () => {
    if (!id) return;

    // ✅ BLOCK DELETE WHEN BALANCE EXISTS
    if (outStandingBalance > 0) {
      notifyError("Customer has outstanding balance. Cannot delete.");
      return;
    }

    setIsDeleting(true);
    try {
      await api.delete(`/app/v1/pos/customer`, { data: { ids: [id] } });

      notifySuccess("Customer deleted successfully");
      setIsDeleted(true);
      refreshCustomerList();
      onClose?.();
    } catch (error: any) {
      console.error("Error deleting customer:", error);
      notifyError(error.response?.data?.message || "Failed to delete customer.");
    } finally {
      setIsDeleting(false);
    }
  };

  return { isDeleting, isDeleted, handleDelete, };
};